import {Output, RatePlanItem} from '../contexts/Configuration';

export const calculateAvailableMinutes = (outputs: Output[], ratePlanItems: RatePlanItem[], currentBalance: number): string => {
    if(ratePlanItems.length === 0)
        return "";

    const ratePlanItemMap = ratePlanItems.reduce((map: { [key: string]: number }, item) => {
        map[item.code] = item.price;
        return map;
    }, {});

    // console.log(ratePlanItemMap)

    if (outputs.length === 0) {
        const totalMin = Math.round(currentBalance / ratePlanItemMap['CAPTIONS_FOR_INPUT_LANG']).toFixed(0);
        console.log(`No outputs, total min: ${totalMin} (${currentBalance} / ${ratePlanItemMap['CAPTIONS_FOR_INPUT_LANG']})`);
        return totalMin;
    }
    const outputsWithTextOnly = outputs.filter(o => o.textOnly).length;
    const outputsWithTranslation = outputs.length - outputsWithTextOnly;

    const textOnlyPrice = outputsWithTextOnly * ratePlanItemMap['TEXT_ONLY_TRANSLATION'];
    const translationsPrice = outputsWithTranslation * ratePlanItemMap['AUDIO_TRANSLATION'];

    const total = Math.round(currentBalance / (textOnlyPrice + translationsPrice)).toFixed(0);
    // console.log(`Outputs: ${outputsWithTextOnly} + ${outputsWithTranslation}. Total min: ${total} (${currentBalance} / (${textOnlyPrice} + ${translationsPrice}) )`);
    return total;
}
